import Cookies from 'js-cookie';

export const PADDLE_POSTAL_CODE_SAMPLES: Record<string, string | null> = {
  US: '10001',
  CA: 'M5H 2N2',
  BR: '01310-100',
  MX: '06600',
  AR: 'C1001',
  CL: '8320000',
  CO: '110111',
  PE: '15001',
  VE: '1010',
  EC: '170150',
  BO: '0000',
  PY: '1209',
  UY: '11000',
  CR: '10101',
  SV: '01101',
  GT: '01001',
  HN: '11101',
  NI: '11001',
  PA: '0801',
  DO: '10101',
  CU: '10100',
  JM: 'JMAKN07',
  TT: '100101',
  BB: 'BB11000',
  GP: '97100',
  MQ: '97200',
  GF: '97300',
  PR: '00901',
  VI: '00801',
  TC: 'TKCA 1ZZ',
  KY: 'KY1-1100',
  BM: 'HM01',
  PM: '97500',
  GB: 'SW1A 1AA',
  DE: '10115',
  FR: '75001',
  IT: '00100',
  ES: '28001',
  PT: '1000-001',
  NL: '1011 AB',
  BE: '1000',
  AT: '1010',
  CH: '8001',
  SE: '111 22',
  NO: '0150',
  DK: '1050',
  FI: '00100',
  IE: 'D01 F5P2',
  PL: '00-001',
  CZ: '110 00',
  SK: '811 01',
  HU: '1011',
  RO: '010011',
  BG: '1000',
  HR: '10000',
  SI: '1000',
  RS: '11000',
  BA: '71000',
  ME: '81000',
  MK: '1000',
  AL: '1001',
  GR: '105 57',
  CY: '1010',
  MT: 'VLT 1117',
  LU: '1009',
  LI: '9490',
  IS: '101',
  EE: '10111',
  LV: 'LV-1050',
  LT: '01001',
  BY: '220000',
  UA: '01001',
  MD: 'MD-2001',
  GE: '0100',
  AM: '0001',
  AZ: 'AZ1000',
  KZ: '010000',
  UZ: '100000',
  TM: '744000',
  KG: '720000',
  TJ: '734000',
  AD: 'AD100',
  MC: '98000',
  SM: '47890',
  VA: '00120',
  GI: 'GX11 1AA',
  FO: '100',
  GL: '3900',
  AX: '22100',
  SJ: '9170',
  IL: '9100001',
  TR: null,
  SA: '11564',
  AE: null,
  QA: null,
  KW: '13001',
  BH: '317',
  OM: '100',
  JO: '11110',
  LB: '1107 2070',
  IQ: '10001',
  YE: null,
  IR: '1111111111',
  JP: '100-0001',
  KR: '03000',
  CN: '100000',
  HK: null,
  TW: '100',
  SG: '018906',
  MY: '50000',
  TH: '10100',
  VN: '100000',
  PH: '1000',
  ID: '10110',
  IN: '110001',
  PK: '44000',
  BD: '1000',
  LK: '00100',
  NP: '44600',
  MM: '11181',
  KH: '12000',
  LA: '01000',
  MN: '14200',
  AU: '2000',
  NZ: '1010',
  PG: '121',
  FJ: null,
  WS: null,
  TO: null,
  ZA: '0001',
  NG: '100001',
  KE: '00100',
  GH: null,
  ET: '1000',
  TZ: null,
  UG: null,
  EG: '11511',
  MA: '10000',
  TN: '1001',
  DZ: '16000',
  MU: '11328',
  RW: null,
  CM: null,
  SN: '10000',
  CI: null,
  ZM: '10101',
  ZW: null,
};

export function getCountryFromCookie(): string | null {
  return Cookies.get('country') ?? null;
}

export function getSamplePostalCode(countryCode?: string | null): string | undefined {
  if (countryCode == null) {
    return undefined;
  }
  return PADDLE_POSTAL_CODE_SAMPLES[countryCode.toUpperCase()] ?? undefined;
}

export function getCheckoutCustomerAddress():
  | { countryCode: string; postalCode?: string }
  | undefined {
  const countryCode = getCountryFromCookie();
  if (countryCode == null || countryCode === '') {
    return undefined;
  }

  const postalCode = getSamplePostalCode(countryCode);

  return {
    countryCode: countryCode.toUpperCase(),
    ...(postalCode != null && { postalCode }),
  };
}
